<adapt-dashboard-element *ngIf="hasActiveConnection$ | async"
                         name="Roles"
                         data-test="person-profile-roles">
    <div adapt-dashboard-title-buttons
         *adaptIfAuthorised="ManagePositionAndRoles;Entity:(person$ | async)">
        <button adaptButton="editBorderless"
                *ngIf="editMode"
                (click)="editRoles()"></button>
    </div>

    <ng-container *adaptLoadingUntilFirstEmit="let roleConnections of roleConnections$">
        <ng-container *ngIf="roleConnections.length > 0;else noRolesTemplate">
            <div *ngFor="let roleConnection of roleConnections"
                 class="d-flex flex-row gap-2 align-items-baseline">
                <adapt-link-role [role]="roleConnection.role"></adapt-link-role>
                <adapt-display-role-connection-handover-status *ngIf="roleConnection.handoverStatus"
                                                               [roleConnection]="roleConnection"></adapt-display-role-connection-handover-status>
                <small>Started {{roleConnection.startDate | adaptDate}}</small>
            </div>
        </ng-container>

        <ng-template #noRolesTemplate>
            This person does not have any active roles in the organisation
        </ng-template>
    </ng-container>
</adapt-dashboard-element>
